// Ant design
import { Button, DatePicker, message, Select, Spin, Tooltip } from 'antd'
import axios from 'axios'
//other
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useLocation } from 'react-router-dom'
// Components
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import AppPageHeader from '../../components/AppPageHeader'
import PageTitle from '../../components/PageTitle'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  ISO_DATE_FORMAT,
  MM_YYYY,
} from '../../constants'
// Layout
import DashboardLayout from '../../layouts/DashboardLayout'
// Styled component
import {
  ContentBoxItem,
  MisionGroupWrap,
  MissionGroupItem,
  MissionGroupsList,
  MissionWrapper,
} from './MissionGroupPageStyled'

import MissionPageList from '../MissionPage/MissionPageList'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent'
import { EmptyText, TitleContentBox } from '../../components/Common/CellText'
import { DocumentInfoList } from '../Documents/InternalDocumentIncomingDocDetailPage/InternalDocumentIncomingDocDetailPageStyled'
import { systemName } from '../../config'
import utils from '../../utils'
import { AppTable } from '../../components/AppTable/AppTable'
import { toJS } from 'mobx'
import { EyeOutlineIcon } from '../../components/AppIcon'
import { blue } from '../../color'
import MissionListV2 from '../MissionPage/MissionListV2'

const { Option } = Select

const reducer = (state, action) => {
  switch (action.type) {
    case ASSIGNEE_TYPE.HANDLER:
      return {
        ...state,
        [ASSIGNEE_TYPE.HANDLER]:
          action.value &&
          `assignee=${encodeURIComponent(action.value)},${
            action.assigneeType
          },${ASSIGNEE_TYPE.HANDLER},${action.fullName || 'unknown'}`,
      }
    default:
      return state
  }
}

const MissionGroupPage = props => {
  const {
    taskStore,
    history,
    loadingAnimationStore,
    selectPeopleStore,
    authenticationStore,
  } = props
  const { currentUser } = authenticationStore
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })

  const { missionQueryParams } = taskStore

  const [loadingList, setLoadingList] = useState(false)
  const [isLoadingMissionGroup, setIsLoadingMissionGroup] = useState(false)
  const [textLoading, setTextLoading] = useState('Đang tải nhiệm vụ...')
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [selectGroup, setSelectGroup] = useState('')
  const [usersFilter, dispatchUserFilter] = useReducer(reducer, {
    [ASSIGNEE_TYPE.HANDLER]:
      queryStringParse.assignee && Array.isArray(queryStringParse.assignee)
        ? queryStringParse.assignee.find(el =>
            el.includes(ASSIGNEE_TYPE.HANDLER)
          )
        : null,
  })
  useEffect(() => {
    if (isRefreshPage) return
    ;(async () => {
      try {
        setIsLoadingMissionGroup(true)
        await taskStore.getTaskListByGroup()
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        setIsLoadingMissionGroup(false)
      }
    })()
  }, [missionQueryParams.date_by, missionQueryParams.from_date])
  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        await taskStore.getTaskLevelList()
        await taskStore.getTaskListByGroup()
        await taskStore.clearUpdateTaskItem()
        selectPeopleStore?.selectGroupData?.PIC?.length > 0 &&
          (await taskStore.getTaskList())
        setIsRefreshPage(false)
        setSelectGroup(Number(selectPeopleStore?.selectGroupData?.PIC[0]?.id))
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      taskStore.clearTaskStoreFilter()
      taskStore.clearTaskList()
      taskStore.clearTaskGroupList()
      selectPeopleStore.clearSelected()
    }
  }, [])

  useEffect(() => {
    if (isRefreshPage || !selectGroup) return
    const source = axios.CancelToken.source()
    ;(async () => {
      // await new Promise(resolve => setTimeout(resolve, 500)).then(() => {
      //   const element = document.getElementById('scroller')
      //   element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      // })
      try {
        setLoadingList(true)
        await taskStore.getTaskList(source.token)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        setLoadingList(false)
      } finally {
        setLoadingList(false)
      }
    })()
    return () => {
      source.cancel()
    }
  }, [missionQueryParams])

  const onChangeMonth = value => {
    if (!value) {
      return message.warning('Vui lòng chọn tháng!')
    }
    taskStore.handleChangeMonth(
      value,
      queryStringParse,
      history,
      'mission-group'
    )
  }

  const handleChangeDateBy = value =>
    taskStore.handleChangeDateBy(
      value,
      queryStringParse,
      history,
      'mission-group'
    )
  useEffect(() => {
    if (!currentUser) return
    if (queryStringParse.assignee && Array.isArray(queryStringParse.assignee)) {
      queryStringParse.assignee.forEach(item => {
        const itemInfo = item.split(',')
        const username = itemInfo[0].split('=')[1]
        if (itemInfo.includes(ASSIGNEE_TYPE.GROUP)) {
          selectPeopleStore.setSelectGroupData({
            ...selectPeopleStore.selectGroupData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.GROUP,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
      })
    }
    if (queryStringParse.PIC === currentUser.username) {
      setActiveTab(ASSIGNEE_TYPE.HANDLER)
      dispatchUserFilter({
        type: 'CHANGE_TAB',
        value: {
          type: ASSIGNEE_TYPE.HANDLER,
          value: currentUser.username,
          fullName: currentUser.name_uppercase,
          assigneeType: ASSIGNEE_TYPE.USER,
        },
      })
      return
    }
  }, [currentUser])

  useEffect(() => {
    taskStore.setMissionQueryParams({
      date_by: queryStringParse.date_by || 'DISPLAY_DATE',
      from_date: !queryStringParse.all_time
        ? queryStringParse.from_date ||
          moment().startOf('month').format(ISO_DATE_FORMAT)
        : null,
      to_date: !queryStringParse.all_time
        ? queryStringParse.to_date ||
          moment().endOf('month').format(ISO_DATE_FORMAT)
        : null,
      assignee: Object.values(usersFilter)
        .filter(item => item)
        .map(item => {
          const assignee = item.split(',')
          if (assignee.length === 3) {
            return assignee.join()
          }
          assignee.pop()
          return assignee.join()
        })
        .join('&'),
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        assignee: Object.values(usersFilter),
        [ASSIGNEE_TYPE.HANDLER]:
          typeof usersFilter[ASSIGNEE_TYPE.HANDLER] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.HANDLER].split(',')[0].substring(9)
            : null,
      },
      {
        skipNull: true,
        arrayFormat: 'index',
      }
    )
    history.replace(`/mission-group?${queryStringStringify}`)
  }, [usersFilter])

  const handleSelectGroup = group => {
    if (selectGroup === group.group_id) {
      setSelectGroup('')
      return
    }

    setSelectGroup(group.group_id)
    dispatchUserFilter({
      type: ASSIGNEE_TYPE.HANDLER,
      value: group.group_id,
      fullName: group.full_name,
      assigneeType: ASSIGNEE_TYPE.GROUP,
    })
  }

  const handleNextMonth = (taskCode, type) =>
    taskStore.handleNextMonth(taskCode, type, setLoadingList, setTextLoading)

  const columns = [
    {
      title: 'Nhóm',
      dataIndex: 'group_id',
      key: 'group_id',
      ellipsis: true,
      width: 250,
      render: (_, record) =>
        record?.group_name ? (
          record.group_name
        ) : (
          <EmptyText>Không rõ</EmptyText>
        ),
    },
    {
      title: 'Hoàn thành',
      dataIndex: 'hoan_thanh',
      key: 'hoan_thanh',
      ellipsis: true,
      // sorter: (a, b) => a.hoan_thanh - b.hoan_thanh,
      width: 150,
    },
    {
      title: 'Chưa hoàn thành',
      dataIndex: 'chua_hoan_thanh',
      key: 'chua_hoan_thanh',
      ellipsis: true,
      // sorter: (a, b) => a.chua_hoan_thanh - b.chua_hoan_thanh,
      width: 150,
    },
    {
      title: 'Thao tác',
      key: 'actions',
      width: 100,
      fixed: 'right',
      align: 'center',
      render: (_, record) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Button
            title="Xem chi tiết"
            onClick={() => handleSelectGroup(record)}
            type="text"
            shape="circle"
            icon={
              <EyeOutlineIcon style={{ width: 16, height: 16, color: blue }} />
            }
          />
        </div>
      ),
    },
  ]

  return (
    <DashboardLayout>
      <Helmet>
        <title>Nhiệm vụ | {systemName} Nhiệm vụ</title>
      </Helmet>
      <AppPageHeader
        title="Danh sách lãnh đạo"
        addon={
          <div style={{ flex: '0 0 300px' }}>
            <Select
              style={{ width: 172, marginRight: 8 }}
              value={missionQueryParams.date_by}
              onChange={handleChangeDateBy}>
              <Option value="DISPLAY_DATE">Lọc theo Tháng hiển thị</Option>
              <Option value="CREATED_DATE">Lọc theo Ngày tạo</Option>
            </Select>
            <DatePicker
              style={{ width: 120 }}
              onChange={onChangeMonth}
              defaultValue={
                !queryStringParse.all_time
                  ? (queryStringParse.from_date &&
                      moment(queryStringParse.from_date)) ||
                    moment()
                  : null
              }
              picker="month"
              placeholder={'Chọn tháng'}
              format={MM_YYYY}
            />
          </div>
        }
      />

      <AppTable
        size="small"
        columns={columns}
        dataSource={taskStore.taskGroupList || []}
        rowKey="group_id"
        expandable={{
          expandedRowKeys: selectGroup ? [selectGroup] : [],
          expandIconColumnIndex: -1,

          expandedRowRender: record => {
            return selectGroup ? (
              <Spin spinning={isLoadingMissionGroup || loadingList}>
                <h3 style={{ marginBottom: 20, fontWeight: 500, fontSize: 14 }}>
                  Danh sách nhiệm vụ của nhóm: {record.group_name}
                </h3>
                <MissionListV2
                  showInMissionGroupPage={true}
                  handleNextMonth={handleNextMonth}
                  activeTab={'ALL'}
                  loadingList={false}
                  textLoading={textLoading}
                />
              </Spin>
            ) : (
              ''
            )
          },
        }}
      />

      {/* <ContentBlockWrapper>
        <MisionGroupWrap>
          <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoadingMissionGroup}
            backGround={'#ffffffc7'}
          />
        </MisionGroupWrap>
        <MissionWrapper id="scroller">
          {selectGroup ? (
            <MissionPageList
              handleNextMonth={handleNextMonth}
              activeTab={'ALL'}
              loadingList={false}
              textLoading={textLoading}
            />
          ) : (
            ''
          )}
          <SpinnerInlineComponent
            sizeSpin={'small'}
            tip="Đang tải dữ liệu..."
            isLoading={loadingList}
            backGround={'#ffffffc7'}
          />
        </MissionWrapper>
      </ContentBlockWrapper> */}
    </DashboardLayout>
  )
}

MissionGroupPage.propTypes = {}

export default inject(
  'taskStore',
  'commonStore',
  'loadingAnimationStore',
  'authenticationStore',
  'departmentStore',
  'selectPeopleStore'
)(observer(MissionGroupPage))
